// extracted by mini-css-extract-plugin
export default {"search":"Search_search__Wncrn","input":"Search_input__PXR0c","search_button":"Search_search_button__vtitp"};